module.exports = __webpack_public_path__ + "static/media/plan-B1a-desktop-sc.9e84f0bb.png";